// Accesos al pago y al portal de Stripe usados por las pantallas del recorrido.
import axiosInstance from '../../config/axiosInstance';

export const SUPPORT_EMAIL = 'soporte@proapricing.ai';

export async function openBillingPortal(): Promise<void> {
  const { data } = await axiosInstance.post('/subscriptions/create-portal-session');
  window.location.href = data.url;
}

export async function startCheckout(priceKey: string): Promise<void> {
  const { data } = await axiosInstance.post('/subscriptions/create-checkout-session', { price_key: priceKey });
  window.location.href = data.url;
}

export const formatLongDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

export const PLAN_LABEL: Record<string, string> = { growth: 'Growth', autonomy: 'Autonomy' };

// PRC-021 / PRC-023: suscripción actual leída de Stripe por el servidor.
export interface CurrentSubscription {
  has_subscription: boolean;
  plan?: 'growth' | 'autonomy' | null;
  interval?: 'month' | 'year' | null;
  status?: string;
  cancel_at_period_end?: boolean;
  current_period_end?: string | null;
  cancel_at?: string | null;
  started_at?: string | null;
  amount?: number;
  currency?: string | null;
  card_brand?: string | null;
  card_last4?: string | null;
  billing_name?: string | null;
  invoice_url?: string | null;
  invoice_pdf?: string | null;
  last_charge_amount?: number | null;
  last_charge_at?: string | null;
  users_used?: number | null;
  users_max?: number | null;
}

export const CURRENT_SUBSCRIPTION_QUERY_KEY = ['pricing-current-subscription'];

export async function fetchCurrentSubscription(): Promise<CurrentSubscription> {
  const { data } = await axiosInstance.get<CurrentSubscription>('/subscriptions/current');
  return data;
}

export const formatMoney = (cents: number | null | undefined, currency?: string | null) => {
  if (cents == null) return '';
  const value = cents / 100;
  const symbol = !currency || currency.toLowerCase() === 'eur' ? '€' : currency.toUpperCase();
  const amount = value.toLocaleString('es-ES', { minimumFractionDigits: Number.isInteger(value) ? 0 : 2, maximumFractionDigits: 2, useGrouping: true });
  return `${amount.replace(/^(\d)(\d{3})(?=,|$)/, '$1.$2')} ${symbol}`;
};

export const formatShortDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }) : '';

export const intervalLabel = (interval?: string | null) => (interval === 'year' ? 'anual' : interval === 'month' ? 'mensual' : '');

export const DATA_RETENTION_DAYS = 90;
